import type { User } from '../../models/User';
import { delay, readCollection, seedCollection, writeCollection } from './dataverseClient';
import { usersSeed } from './mockData';

const ENTITY = 'cr_crm_user';

class UserService {
  private ensureSeed(): void {
    seedCollection(ENTITY, usersSeed);
  }

  async list(): Promise<User[]> {
    this.ensureSeed();
    await delay();
    return readCollection<User>(ENTITY);
  }

  async getById(id: string): Promise<User | null> {
    this.ensureSeed();
    await delay();
    return readCollection<User>(ENTITY).find((item) => item.cr_crm_userid === id) ?? null;
  }

  async getByEmail(email: string): Promise<User | null> {
    this.ensureSeed();
    await delay();
    return readCollection<User>(ENTITY).find((item) => item.cr_crm_email.toLowerCase() === email.toLowerCase()) ?? null;
  }

  async getDefaultUser(): Promise<User> {
    this.ensureSeed();
    await delay();
    return readCollection<User>(ENTITY)[0];
  }

  async touchLastLogin(id: string): Promise<void> {
    this.ensureSeed();
    await delay();
    const users = readCollection<User>(ENTITY).map((item) => item.cr_crm_userid === id ? { ...item, cr_crm_lastloginat: new Date().toISOString() } : item);
    writeCollection(ENTITY, users);
  }
}

export const userService = new UserService();
